import React from "react"
import Toggle from "../Toggle"
import styled from "styled-components"
import { lightTheme, darkTheme } from "../../theme"

const HeaderContainer = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: ${({ theme }) => (theme === "light" ? lightTheme.primary : darkTheme.primary)};
    color: ${({ theme }) => (theme === "light" ? lightTheme.textOnPrimary : darkTheme.textOnPrimary)};
    transition: all 0.25s linear;
    height: 60px;
    width: 100%;
    padding: 0 20px;
    box-shadow: 0 1px 1px ${({ theme }) => (theme === "light" ? "grey" : "black")};

    & > * {
        align-self: center;
    }
`

export default function Header({ theme, toggleTheme }: { theme: string; toggleTheme: () => void }): JSX.Element {
    return (
        <HeaderContainer theme={theme}>
            <h2 className="text-lg">{"Sort Visualizer"}</h2>
            <Toggle theme={theme} toggleTheme={toggleTheme} />
        </HeaderContainer>
    )
}
